import { createAsyncThunk } from '@reduxjs/toolkit';

export const rejectHistoryFetchAction = createAsyncThunk('history/rejectHistoryFetch', (error: Error) =>
  Promise.reject(error)
);
